import { FC } from "react";
import classNames from "classnames";
import { League as LeagueType } from "../sport-table/types/football_table";
import League from "./league";
import Match from "./match";
import { THEME, THEME_LIVE } from "./config";
import { fixed2Position } from "./helper";
import "./index.css";
import SpecialPrice from "./special-price";
import Loading from "../Loading";

export type SportTableProps = {
  sport?: string;
  tableType?: string;
  oddsType?: number;
  isLive?: boolean;
  hasMl?: boolean;
  data?: LeagueType[];
  isLoading?: boolean;
  isFlagVisible?: boolean;
  specialData?: any;
  isLoadingSpecialData?: boolean;
  onClickMore?: (matchId: string) => void;
  onClickPinFavorite?: (
    payload: { id: string; name: string },
    type: "LEAGUE" | "TEAM",
  ) => void;
  focusMatchId?: string;
  onClickPrice?: (data: {
    outcomeId: string;
    marketId: string;
    sp: string;
    matchId: string;
    leagueId: string;
    option: number;
  }) => void;
  onClickSpecialPrice?: (data: {
    outcomeId: string;
    marketId: string;
    sp: string;
    matchId: string;
    leagueId: string;
    option: number;
  }) => void;
  onClickShare?: (data: { leagueId: string; matchId: string }) => void;
};

const SportTable: FC<SportTableProps> = ({
  sport,
  tableType,
  onClickPrice,
  oddsType = 0,
  isLive = false,
  hasMl = false,
  data = [],
  isLoading = false,
  isFlagVisible = false,
  focusMatchId,
  onClickMore,
  onClickPinFavorite,
  specialData,
  isLoadingSpecialData,
  onClickSpecialPrice,
  onClickShare,
}) => {
  const theme = isLive ? THEME_LIVE : THEME;

  if (isLoading) {
    return <Loading size={50} className="my-20 mx-auto" />;
  }

  return (
    <>
      {data.length === 0 && (
        <League
          isFlagVisible={isFlagVisible}
          className="border-b"
          isLive={isLive}
          hasMl={hasMl}>
          <Match isLive={isLive} className={theme.secordaryA} />
        </League>
      )}
      {data.map((league, index) => (
        <League
          isFlagVisible={isFlagVisible}
          className={data.length - 1 === index ? "border-b" : ""}
          key={league.id}
          isLive={isLive}
          hasMl={hasMl}
          onClickPinFavorite={onClickPinFavorite}
          data={league}>
          {league.matches.map((match, indexMatch) => {
            const date = new Date(match.date);
            const isToday = date.getDate() === new Date().getDate();
            const isSpecialOpen = focusMatchId === `${match.id}`;

            const handleShare =
              onClickShare ?
                () =>
                  onClickShare({
                    leagueId: String(league.id),
                    matchId: String(match.id),
                  })
              : undefined;

            return (
              <Match
                hasTips={match.has_tips}
                tableType={tableType}
                sport={sport}
                oddsType={oddsType}
                key={match.id}
                isLive={isLive}
                isFlagVisible={isFlagVisible}
                hasMl={hasMl}
                isSpecialOpen={isSpecialOpen}
                data={match}
                onClickMore={onClickMore}
                className={classNames({
                  [theme.secordaryA]: indexMatch % 2 === 0,
                  [theme.secordaryB]: indexMatch % 2 !== 0,
                })}
                onClickPrice={onClickPrice}
                onClickShare={handleShare}
                date={
                  isLive ? match.live_time
                  : isToday ?
                    `${fixed2Position(date.getHours())}:${fixed2Position(
                      date.getMinutes(),
                    )}`
                  : `${fixed2Position(date.getDate())}/${fixed2Position(
                      Number(date.getMonth()) + 1,
                    )}\n${fixed2Position(date.getHours())}:${fixed2Position(
                      date.getMinutes(),
                    )}`

                }>
                {isSpecialOpen && (
                  <tr className={classNames(theme.borderColor, "border-t")}>
                    <td colSpan={20}>
                      <SpecialPrice
                        isLive={isLive}
                        isLoading={isLoadingSpecialData}
                        data={specialData}
                        matchId={`${match.id}`}
                        onClickSpecialPrice={onClickSpecialPrice}
                        leagueId={`${league.id}`}
                        oddsType={oddsType}
                      />
                    </td>
                  </tr>
                )}
              </Match>
            );
          })}
        </League>
      ))}
    </>
  );
};

export default SportTable;
